import { useCallback } from 'react';
import { LiveDraft } from '@utils/editors/live-transcript-state.ts';
import { LiveUtterance } from '@utils/types/editors/live-transcript.ts';

type Props = {
  canEdit: boolean;
  commit: (update: (current: LiveDraft[]) => LiveDraft[]) => void;
  scheduleSpeakerSave: (id: string) => void;
};

export const useLiveTranscriptEditor = ({
  canEdit,
  commit,
  scheduleSpeakerSave
}: Props) => {
  const edit = useCallback(
    (id: string, utterance: LiveUtterance) => {
      commit(previous =>
        previous.map(row =>
          row.segment.segment_id === id
            ? {
                ...row,
                segment: { ...row.segment, utterance },
                serverSegment: row.serverSegment ?? row.segment,
                dirty: true,
                textDirty: true,
                editVersion: row.editVersion + 1
              }
            : row
        )
      );
    },
    [commit]
  );
  const editSpeaker = useCallback(
    (id: string, speaker: string) => {
      if (!canEdit) return;
      commit(previous =>
        previous.map(row =>
          row.segment.segment_id === id
            ? {
                ...row,
                segment: {
                  ...row.segment,
                  utterance: { ...row.segment.utterance, speaker }
                },
                serverSegment: row.serverSegment ?? row.segment,
                dirty: true,
                speakerDirty: true,
                editVersion: row.editVersion + 1,
                speakerEditVersion: row.editVersion + 1
              }
            : row
        )
      );
      scheduleSpeakerSave(id);
    },
    [canEdit, commit, scheduleSpeakerSave]
  );
  return { edit, editSpeaker };
};
